import React from 'react';
import {
  Input,
  Select,
  FormControl,
  FormLabel,
  Textarea,
  InputGroup,
  InputLeftElement,
  Box,
} from '@chakra-ui/react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';

const ReusableInput = ({
  label = "",
  name,
  value,
  onChange,
  placeholder,
  placeholderColor = "#A0AEC0",
  type = 'text',
  options = [],
  required = true,
  borderRadius = "12px",
  focusBorderColor = "#071D54",
  bg = "#F5F5F5",
  borderColor = "#F5F6FA",
  height = "48px",
  color = "black",
  icon,
  editorHeight = "",
  isDisabled = false,
}) => {
  return (
    <FormControl isRequired={required} mb={4}>
      {label && (
        <FormLabel fontSize="sm" color="#8D93A1" requiredIndicator={null}>
          {label}
        </FormLabel>
      )}

      {type === 'select' ? (
        <Select
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          borderRadius={borderRadius}
          borderColor={borderColor}
          height={height}
          focusBorderColor={focusBorderColor}
          bg={bg}
          color={color}
          isDisabled={isDisabled}
        >
          {options.map((option, index) => (
            <option key={index} value={option.value}>{option.label}</option>
          ))}
        </Select>
      ) : type === 'textarea' ? (
        <Textarea
          name={name}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          borderRadius={borderRadius}
          borderColor={borderColor}
          focusBorderColor={focusBorderColor}
          bg={bg}
          height="90px"
          p="12px"
          color={color}
          isDisabled={isDisabled}
        />
      ) : type === 'richtext' ? (
        <Box
          borderRadius={borderRadius}
          border="2px solid"
          borderColor={borderColor}
          bg={bg}
          _focusWithin={{ borderColor: focusBorderColor }}
          color={color}
        >
          <ReactQuill
            value={value}
            onChange={(val) => onChange({ target: { name, value: val } })}
            placeholder={placeholder}
            style={{
              height: editorHeight,
              borderRadius,
              pointerEvents: isDisabled ? 'none' : 'auto', 
              opacity: isDisabled ? 0.6 : 1,               
            }}
            theme="snow"
          />
          <style>
            {`
              .ql-toolbar.ql-snow {
                border-top-left-radius: ${borderRadius};
                border-top-right-radius: ${borderRadius};
                background-color: ${bg};
                border-color: ${borderColor};
              }
              .ql-container.ql-snow {
                border-bottom-left-radius: ${borderRadius};
                border-bottom-right-radius: ${borderRadius};
                border-color: ${borderColor};
                background-color: ${bg};
                color: ${color};
              }
              .ql-editor {
                min-height: ${editorHeight};
                color: ${color};
                font-size: 14px;
              }
            `}
          </style>
        </Box>
      ) : (
        <InputGroup>
          {icon && (
            <InputLeftElement pointerEvents="none" width="40px" mt={1}>
              {icon}
            </InputLeftElement>
          )}
          <Input
            name={name}
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            type={type}
            borderRadius={borderRadius}
            borderColor={borderColor}
            height={height}
            focusBorderColor={focusBorderColor}
            bg={bg}
            color={color}
            pl={icon ? "40px" : "16px"}
            isDisabled={isDisabled} 
          />
        </InputGroup>
      )}
    </FormControl>
  );
};


export default ReusableInput;
